import styles from './TermsPage.module.css';

const TermsPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>이용약관</h1>

        <section className={styles.section}>
          <h2>제 1 조 (목적)</h2>
          <p>
            이 약관은 Writon(이하 "운영자")이 제공하는 블로그 서비스(이하 "서비스")의 이용과 관련하여
            운영자와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
          </p>
        </section>

        <section className={styles.section}>
          <h2>제 2 조 (용어의 정의)</h2>
          <ol>
            <li>"서비스"란 운영자가 제공하는 블로그 플랫폼 및 관련 제반 서비스를 의미합니다.</li>
            <li>"회원"이란 이 약관에 동의하고 운영자와 서비스 이용계약을 체결한 자를 말합니다.</li>
            <li>"게시물"이란 회원이 서비스를 이용함에 있어 서비스에 게시한 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 3 조 (약관의 효력 및 변경)</h2>
          <ol>
            <li>이 약관은 서비스를 이용하고자 하는 모든 회원에 대하여 그 효력을 발생합니다.</li>
            <li>운영자는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 이 약관을 변경할 수 있습니다.</li>
            <li>약관이 변경되는 경우 운영자는 변경사항을 시행일자 7일 전부터 서비스 내 공지사항을 통해 공지합니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 4 조 (회원가입)</h2>
          <ol>
            <li>회원가입은 이용자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 운영자가 이러한 신청에 대하여 승낙함으로써 체결됩니다.</li>
            <li>운영자는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
              <ul>
                <li>타인의 명의를 이용한 경우</li>
                <li>허위의 정보를 기재하거나, 운영자가 제시하는 내용을 기재하지 않은 경우</li>
                <li>관계법령에 위배되거나 사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한 경우</li>
              </ul>
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 5 조 (회원 정보의 변경)</h2>
          <p>
            회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.
            회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 기타 방법으로 운영자에 대하여 그 변경사항을 알려야 합니다.
          </p>
        </section>

        <section className={styles.section}>
          <h2>제 6 조 (개인정보의 보호)</h2>
          <ol>
            <li>운영자는 관련법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다.</li>
            <li>회원 개인정보의 보호 및 사용에 대해서는 관련법령 및 운영자의 개인정보처리방침이 적용됩니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 7 조 (회원의 의무)</h2>
          <p>회원은 다음 행위를 하여서는 안 됩니다.</p>
          <ol>
            <li>신청 또는 변경 시 허위내용의 등록</li>
            <li>타인의 정보도용</li>
            <li>운영자가 게시한 정보의 변경</li>
            <li>운영자가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
            <li>운영자와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
            <li>운영자 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
            <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 8 조 (게시물의 저작권)</h2>
          <ol>
            <li>회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.</li>
            <li>운영자는 게시된 게시물을 서비스의 운영, 전시, 전송, 배포 등을 위하여 필요한 범위 내에서 사용할 수 있습니다.</li>
            <li>회원은 서비스를 이용하여 취득한 정보를 임의 가공, 판매하는 행위 등 서비스에 게재된 자료를 상업적으로 사용할 수 없습니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 9 조 (게시물의 관리)</h2>
          <ol>
            <li>회원의 게시물이 정보통신망법 및 저작권법 등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 운영자는 관련법에 따라 조치를 취하여야 합니다.</li>
            <li>운영자는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 운영자 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 10 조 (서비스의 제공 및 변경)</h2>
          <ol>
            <li>운영자는 회원에게 아래와 같은 서비스를 제공합니다.
              <ul>
                <li>블로그 게시물 작성, 수정, 삭제 서비스</li>
                <li>댓글 작성, 수정, 삭제 서비스</li>
                <li>게시물 및 댓글 좋아요 서비스</li>
                <li>카테고리 및 태그 관리 서비스</li>
                <li>회원정보 변경 서비스 (닉네임, 이메일, 비밀번호 등)</li>
                <li>소셜 로그인 연동 서비스 (Google, GitHub)</li>
                <li>프로필 관리 서비스</li>
                <li>기타 운영자가 추가 개발하거나 다른 운영자와의 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
              </ul>
            </li>
            <li>운영자는 필요한 경우 서비스의 내용을 변경할 수 있으며, 변경 시 그 내용을 서비스 화면에 공지합니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 11 조 (서비스의 중단)</h2>
          <ol>
            <li>운영자는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
            <li>운영자는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 운영자가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 12 조 (계약해지 및 이용제한)</h2>
          <ol>
            <li>회원은 언제든지 서비스 이용을 원하지 않는 경우 회원 탈퇴를 통해 이용계약을 해지할 수 있습니다.</li>
            <li>운영자는 회원이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 13 조 (책임제한)</h2>
          <ol>
            <li>운영자는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
            <li>운영자는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
            <li>운영자는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖에 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 14 조 (분쟁해결)</h2>
          <ol>
            <li>운영자는 회원이 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치 운영합니다.</li>
            <li>운영자와 회원 간 발생한 분쟁은 전자문서 및 전자거래기본법에 의해 설치된 전자문서·전자거래분쟁조정위원회의 조정에 따를 수 있습니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>제 15 조 (재판권 및 준거법)</h2>
          <ol>
            <li>이 약관에 명시되지 않은 사항은 관계법령 및 상관례에 따릅니다.</li>
            <li>서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 운영자의 본사 소재지를 관할하는 법원을 관할 법원으로 합니다.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <p className={styles.effective}>시행일자: 2026년 1월 14일</p>
        </section>
      </div>
    </div>
  );
};

export default TermsPage;
